import { __asyncGenerator, __await } from "tslib";
import { AsyncIterableX } from './asynciterablex.mjs';
import { throwIfAborted } from '../aborterror.mjs';
class EmptyAsyncIterable extends AsyncIterableX {
    [Symbol.asyncIterator](signal) {
        return __asyncGenerator(this, arguments, function* _a() {
            throwIfAborted(signal);
        });
    }
}
/**
 * Returns an empty async-iterable sequence.
 *
 * @template TSource The type used for the async-iterable type parameter of the resulting sequence.
 * @returns {AsyncIterableX<never>} An async-iterable sequence with no elements.
 */
export function empty() {
    return new EmptyAsyncIterable();
}

//# sourceMappingURL=empty.mjs.map
